<template>
    <div class="ext-page-loading">
      <p>
        <img src="@/assets/nodata01.png" />
        <b>{{title}}</b>
      </p>
    </div>
</template>

<script>
export default {
  name: 'ExtLoading',
  props: {
    title: {
      type: String,
      default () {
        return '暂无内容'
      }
    }
  }
}
</script>
<style scoped>
.ext-page-loading { width:100% !important; height:auto; flex-wrap:wrap; align-content:flex-start; margin-top:20px;}
  .ext-page-loading p { width:300px; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .ext-page-loading p img { width:100px; height:100px; margin:0px 100px;}
  .ext-page-loading p b { width:300px; height:20px; float:left; font-weight: normal; text-align: center !important; line-height:20px; font-size:12px; color:#666666; justify-content:center;}
</style>



// WEBPACK FOOTER //
// src/components/loading/index.vue